import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import admin from './locales/fr/admin.json';
import auth from './locales/fr/auth.json';
import common from './locales/fr/common.json';
import dashboard from './locales/fr/dashboard.json';
import navigation from './locales/fr/navigation.json';
import pro from './locales/fr/pro.json';
import products from './locales/fr/products.json';
import publicNs from './locales/fr/public.json';
import seller from './locales/fr/seller.json';
import seo from './locales/fr/seo.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: {
        common,
        auth,
        products,
        admin,
        dashboard,
        public: publicNs,
        seo,
        navigation,
        seller,
        pro,
      },
    },
    fallbackLng: 'fr',
    defaultNS: 'common',
    ns: ['common', 'auth', 'products', 'admin', 'dashboard', 'public', 'seo', 'navigation', 'seller', 'pro'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'mydar-language',
      caches: ['localStorage'],
    },
  });

document.documentElement.lang = i18n.language;
i18n.on('languageChanged', (lng: string) => {
  document.documentElement.lang = lng;
});

export default i18n;
